import React from "react";
import PropTypes from "prop-types";
import ValuePicker from "./ValuePicker";

const ScopeProjectsPicker = ({ projects, onChange, sourceTypeId, excludeSourceId }) => {
  const onToggle = (v) => {
    if (projects.includes(v)) onChange(projects.filter((x) => x !== v));
    else onChange([...projects, v]);
  };
  return (
    <div>
      {projects.length === 0 && (
        <div className="mb-2 inline-flex items-center gap-1 rounded-full bg-warning-soft px-2 py-0.5 text-[11px] text-warning">
          <span aria-hidden>⚠</span> All projects (including projects added later)
        </div>
      )}
      <ValuePicker
        facet="project"
        labelKey=""
        selected={projects}
        onToggle={onToggle}
        initialSearch=""
        sourceTypeId={sourceTypeId}
        excludeSourceId={excludeSourceId}
      />
    </div>
  );
};

ScopeProjectsPicker.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  sourceTypeId: PropTypes.string,
  excludeSourceId: PropTypes.number,
};

export default ScopeProjectsPicker;
